import { getRandomCompanyTypeOfWriting, getRandomEmoji, getRandomEmojiPosition } from "../simulatedTransaction/functions";

//подстановка в шаблон hook-заголовка конкретных значений
export const formatHook = (template: string, company: string, ticker: string) => {
  let title = template;

  //меняем в шаблоне стандартный эмодзи 🔥 в середине на нужный и в нужном положении в тексте
  const emojiPosition = getRandomEmojiPosition();
  const emoji = getRandomEmoji();
  const emojiFormat = `<span data-accent="emoji">${emoji}</span>`;
  if (emojiPosition === "None") {
    title = title.replace("🔥 ", "");
  } else if (emojiPosition === "Start") {
    title = title.replace("🔥 ", "");
    title = emojiFormat + " " + title;
  } else if (emojiPosition === "Center") {
    title = title.replace("🔥", emojiFormat);
  } else if (emojiPosition === "End") {
    title = title.replace("🔥 ", "");
    title = title + " " + emojiFormat;
  }

  //меняем в шаблоне стандартную компанию Apple Inc. на нужную и в рандомном из трех вариантов написаний
  const companyTypeOfWriting = getRandomCompanyTypeOfWriting();
  const companyWithoutDot = company.endsWith(".") ? company.slice(0, -1) : company;
  if (companyTypeOfWriting === "Company") {
    const companyFormat = `<span data-accent="company">${companyWithoutDot}</span>`;
    title = title.replace("Apple Inc", companyFormat);
  } else if (companyTypeOfWriting === "Ticker") {
    const tickerFormat = `<span data-accent="ticker">${ticker}</span>`;
    title = title.replace("Apple Inc", tickerFormat);
  } else if (companyTypeOfWriting === "Both") {
    const companyFormat = `<span data-accent="company">${companyWithoutDot}</span>`;
    const tickerFormat = `(<span data-accent="ticker">${ticker}</span>)`;
    title = title.replace("Apple Inc", companyFormat + " " + tickerFormat);
  }

  return title;
};
